<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 ml-auto mr-auto text-center">
        <h1 class="title">Vous prendrez quelle formule ?</h1>
        <h4 class="description">
          Toutes les fonctionnalités principales sont dans la formule
          basique.<br />
          Vous souhaitez stocker vos données plus longtemps et accèder à de
          nouveaux outils ? <b>Connectez-vous pour passer Pro.</b>
        </h4>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md-4 offset-md-2">
        <card
          type="pricing"
          class="card-success card-pricing card-white"
          footer-classes="text-center mb-3 mt-3"
        >
          <h1 class="card-title">Basique</h1>
          <img class="card-img" src="img/card-success.png" alt="Image" />
          <ul class="list-group">
            <li class="list-group-item">Cotation hebdo+daily</li>
            <li class="list-group-item">Screeners</li>
            <li class="list-group-item">Indicateurs</li>
            <li class="list-group-item">Stockage basique</li>
            <li class="list-group-item"></li>
          </ul>
          <div class="card-prices">
            <h3 class="text-on-front">0<span>€</span></h3>
            <h5 class="text-on-back">0</h5>
            <p class="plan">Formule basique</p>
          </div>

          <base-button slot="footer" round type="success" class="btn-just-icon">
            <router-link class="pointer" tag="span" to="/login"
              >Démarrer</router-link
            >
          </base-button>
        </card>
      </div>

      <div class="col-md-4">
        <card
          type="pricing"
          class="card-primary card-raised card-pricing"
          footer-classes="text-center mb-3 mt-3"
        >
          <h1 class="card-title">pro</h1>
          <img class="card-img" src="img/card-primary.png" alt="Image" />
          <ul class="list-group">
            <li class="list-group-item">Stockage avancé</li>
            <li class="list-group-item">Création de Watchlist</li>
            <li class="list-group-item">Historique des positions</li>
            <li class="list-group-item">Prise de notes</li>
            <li class="list-group-item">
              Stockage des AT
              <el-tooltip
                :content="
                  'Vos analyses graphiques sur chaque instruments sont sauvegardées.'
                "
                effect="light"
                :open-delay="100"
                placement="top"
              >
                <i class="fas fa-info-circle"></i>
              </el-tooltip>
            </li>
          </ul>
          <div class="card-prices">
            <h3 class="text-on-front">5€/mois</h3>
            <h5 class="text-on-back">5€</h5>
            <p class="plan">Formule pro</p>
          </div>

          <base-button slot="footer" round type="primary" class="btn-just-icon">
            <router-link class="pointer" tag="span" to="/login"
              >Démarrer</router-link
            >
          </base-button>
        </card>
      </div>
    </div>

    <!-- <div class="row align-items-center mt-5" style="min-height: 60vh">
      <div class="d-none d-md-block col-md-6">
        <figure class="ie-non-standard-hero-shape">
          <svg x="0px" y="0px" 
            viewBox="10 12 878.9 907" 
            style="enable-background:new 10 12 878.9 907;" 
            xml:space="preserve" 
            class="injected-svg js-svg-injector" 
            data-img-paths="[ {&quot;targetId&quot;: &quot;#imageShape1&quot;, &quot;newPath&quot;: &quot;/img/bg6.jpeg&quot;},
                          {&quot;targetId&quot;: &quot;#imageShape2&quot;, &quot;newPath&quot;: &quot;/img/bg6.jpeg&quot;}]" 
                          data-parent="#SVGNonStandardHeroShape">
            <g>
              <defs>
                <path id="firstShape" d="M299.27,772.72s-24.67-76.08-131.42-51.33C62.82,745.74,81.48,563.56,92,495.71S193.94,92.18,454.77,76.46,658.58,250.62,632.75,306s-78.37,115.53,16.76,295.77-89.33,258.1-129.36,265.84S375.3,912.41,299.27,772.72Z"></path>
              </defs>
              <clipPath id="secondShape">
                <use xlink:href="#firstShape" style="overflow:visible;"></use>
              </clipPath>
              <g clip-path="url(#secondShape)">
                <image id="imageShape1" style="overflow:visible;" width="1000" height="1000" xlink:href="/img/bg6.jpeg" transform="matrix(0.9488 0 0 0.9488 25 53.1187)"></image>
              </g>
            </g>
            <g>
              <defs>
                <path id="thirdShape" d="M741.49,643q-2.58-.31-5.17-.4c-12-.45-46.58-14.37-79.24-71.85-17.81-31.35-47.32-96.41-37.88-167.21,7.84-58.79,38.38-97.1,48.34-130.64,24.82-83.61,66.62-77.07,98-77.07,15.93,0,31.1,14.82,39.21,26.39,11.55,16.48,19.72,46.24-9.1,93.32-60.66,99.07,14.09,139.33-.93,239.68C781.72,641.8,750,644,741.49,643Z"></path>
              </defs>
              <clipPath id="fourthShape">
                <use xlink:href="#thirdShape" style="overflow:visible;"></use>
              </clipPath>
              <g transform="matrix(1 0 0 1 0 0)" clip-path="url(#fourthShape)">
                <image id="imageShape2" style="overflow:visible;" width="1000" height="1000" xlink:href="/img/bg6.jpeg" transform="matrix(0.9488 0 0 0.9488 25 53.1187)"> </image>
              </g>
            </g>
          </svg>
        </figure>
      </div>
      <div class="col-12 col-md-5">
        <h1 class="mb-0">L’association du moment</h1>
        <h4 class="text-info mb-4">Association Petits Princes</h4>
        Depuis 1987, l’Association Petits Princes réalise les rêves d’enfants et adolescents malades, atteints de cancers, de leucémies, de certaines maladies génétiques …
        <br><br>
        <b>L’objectif ?</b> Leur permettre de trouver une énergie supplémentaire pour se battre contre la maladie.
        <br>
        La spécificité de l’Association Petits Princes est de pouvoir organiser plusieurs rêves pour un même enfant autour de ses passions, en fonction de l’évolution de sa pathologie.
        <br><br>
        Parce que la maladie bouleverse tout l’univers familial, les parents et la fratrie vivent, dans la majorité des cas, les rêves aux côtés de l’enfant.
        <br><br><br>
        <a href="https://www.petitsprinces.com/" class="text-primary font-weight-bold">
          Découvrir l'association et faire un don
        </a>
      </div>
    </div> -->
  </div>
</template>
<script>
import { BaseProgress } from "src/components";

export default {
  name: "pricing-page",
  components: {
    BaseProgress
  }
};
</script>
<style></style>
